import { tryCatch } from '@thalesrc/js-utils';

import { DateRange } from '../dashboard/widget/widget.payload';
import HSApi from '../HSApi';
import { excelExport, handleResult } from '../utils';

export async function getAccidentCounts(dateRange?: DateRange) {
  const [error, res] = await tryCatch(HSApi.get(`/accidents/widgets/count${dateRange?.toString()}`));

  return handleResult(res, error);
}

export async function getAccidentWidgetView(dateRange: DateRange) {
  const [error, res] = await tryCatch(HSApi.get(`/accidents/widgets/views${dateRange.toString()}`));

  return handleResult(res, error);
}

export async function getAccidentEmployeeView(dateRange: DateRange) {
  const [error, res] = await tryCatch(HSApi.get(`/accidents/employees/widgets/views${dateRange.toString()}`));

  return handleResult(res, error);
}

export async function exportAccidentsWidgetExport(dateRange: DateRange, fileName: string) {
  const [error, res] = await tryCatch(
    HSApi.get(`/accidents/widgets/views/export${dateRange.toString()}`, {
      responseType: 'blob',
    })
  );

  const data = handleResult(res, error);
  excelExport(data, fileName);
}

export async function exportAccidentEmployeesExport(dateRange: DateRange, fileName: string) {
  const [error, res] = await tryCatch(
    HSApi.get(`/accidents/employees/widgets/views/export${dateRange.toString()}`, {
      responseType: 'blob',
    })
  );

  const data = handleResult(res, error);
  excelExport(data, fileName);
}
